import { MenuFoldOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'
import { Button } from 'sutra/components/Button'
import { Tooltip } from 'sutra/components/Tooltip/Tooltip'

import { navDefaultIconColor } from 'assets/styles/variables'

interface CloseSidebarButtonProps {
  onClick: () => void
  title?: React.ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  /** Square size in px for the button. Defaults to 32. */
  size?: number
}

const IconButton = styled(Button)`
  color: ${navDefaultIconColor};

  &&:hover:not(:disabled):not([aria-disabled='true']) {
    background-color: #5072a426;
    color: #28364f;
  }
`

const CloseSidebarButton: React.FC<CloseSidebarButtonProps> = ({
  onClick,
  title = 'Close sidebar',
  side = 'right',
  size = 32,
}) => {
  return (
    <Tooltip content={title} side={side}>
      <IconButton
        variant="text"
        height={`${size}px`}
        icon={<MenuFoldOutlined />}
        aria-label={typeof title === 'string' ? title : undefined}
        onClick={onClick}
      />
    </Tooltip>
  )
}

export default CloseSidebarButton
